import React from "react";
import Datatable from "../../../components/datatable";
import {fmtDateTime} from "../../../functions/formatDate";

/**
 *
 * @deprecated Old implementation
 */
const EntranceTable = ({data,setData})=>{

    let tableData = React.useMemo(() => {
        return data;
    }, [data])


    let columns = React.useMemo(() => [
        {Header: 'BC', accessor: 'bc'},
        {Header: 'Datum', accessor: 'date', Cell: ({value}) => fmtDateTime(value)},
        {Header: 'Událost id', accessor: 'eventId'},
        {Header: 'Turniket',accessor: d=>d.turnstile?d.turnstile.description + " ("+d.turnstile.ipAddress+")":"-"},
        {Header: 'Výsledek',accessor: d=>d.result==="OK"?<span className={"text-green-600 font-bold"}>{d.result}</span>:<span className={"text-red-600 font-bold"}>{d.result}</span>},
        {Header: 'Typ', accessor: d => d.typeEntrance === 1 ? "Vchod" : "Východ"}
    ])

    return <Datatable data={tableData} columns={columns} selectable={false} />
}
export default EntranceTable;
